import React, { useState } from "react";
import useBackdropClose from "../../hooks/useBackdropClose";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { API_URL } from "../../config/constants";
import {
  Overlay, Modal, ModalTitle, Label, Textarea, Counter,
  ActionRow, CancelButton, SaveButton,
} from "./styles";

const MESSAGE_MAX = 500;

/**
 * Mensaje fijo del terapeuta: el paciente lo ve siempre en su home y en
 * Caregiver Support. No es un mensaje de chat, se sobrescribe al editarlo.
 */
const EditPatientMessageModal = ({ patientId, message, onClose, onSaved }) => {
  const { t } = useTranslation();
  const [text, setText] = useState(message || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/patients/${patientId}/message`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ message: text.trim() }),
      });
      if (!res.ok) throw new Error();
      toast.success(t("patientMessage.toastSaved"));
      onSaved();
    } catch {
      toast.error(t("patientMessage.toastError"));
      setLoading(false);
    }
  };

  return (
    <Overlay {...useBackdropClose(onClose)}>
      <Modal onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <ModalTitle>{t("patientMessage.editTitle")}</ModalTitle>

        <Label htmlFor="pm-text">{t("patientMessage.label")}</Label>
        <Textarea
          id="pm-text"
          maxLength={MESSAGE_MAX}
          placeholder={t("patientMessage.placeholder")}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <Counter>{text.length}/{MESSAGE_MAX}</Counter>

        <ActionRow>
          <CancelButton type="button" onClick={onClose}>
            {t("patientMessage.cancel")}
          </CancelButton>
          <SaveButton type="submit" disabled={loading}>
            {loading ? t("patientMessage.saving") : t("patientMessage.save")}
          </SaveButton>
        </ActionRow>
      </Modal>
    </Overlay>
  );
};

export default EditPatientMessageModal;
